var map = {
	"./Flatfinder.gql": "b039",
	"./Posts.gql": "0bc8",
	"./Project.gql": "63e7",
	"./ProjectResidential.gql": "b4e94",
	"./Residential.gql": "c523",
	"./Root.gql": "f461"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "74c3";